export interface Header {
  create: string
  campaigns: string
  reports: string
  help: string
  backToDashboard: string
}

const header: Header = {
  create: "Create",
  campaigns: "Campaigns",
  reports: "Reports",
  help: "Help",
  backToDashboard: "Back to Dashboard",
}

export default header
